type MessageType = "success" | "error" | "info" | "warning";

export interface MessageProps {
  type: MessageType;
  text: string;
}

export function Message({ type, text }: MessageProps) {
  const role = type === "error" ? "alert" : "status";
  return (
    <div className={`message ${type}`} role={role}>
      {text}
    </div>
  );
}
